import { z } from 'zod';
import { makeFieldSchemaFromZod } from '../../utils/index.esm.js';

const UploadFileFieldPickerSchema = makeFieldSchemaFromZod(
  z.string(),
  z.object({
    format: z.string().nonempty("Format is required").describe("Format used YAML or JSON ")
  })
);
const UploadFilePickerSchema = UploadFileFieldPickerSchema.schema;

export { UploadFileFieldPickerSchema, UploadFilePickerSchema };
//# sourceMappingURL=schema.esm.js.map
